import { render, staticRenderFns } from "./Logger.vue?vue&type=template&id=55c593ea&scoped=true"
import script from "./Logger.vue?vue&type=script&lang=js"
export * from "./Logger.vue?vue&type=script&lang=js"
import style0 from "./Logger.vue?vue&type=style&index=0&id=55c593ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c593ea",
  null
  
)

export default component.exports